// extracted by mini-css-extract-plugin
export var productImage = "_qv-1";
export var viewLink = "_qv-2";
export var wishlistItem = "_qv-0";